module.exports = __webpack_public_path__ + "img/course2.8bef0d11.jpg";